import { NodePalette } from '../nodes/palette/NodePalette';

export function NodePaletteShell() {
  return <NodePalette />;
}
